import { QUERIES_LOAD_SUCCESS } from "../actions";

const QUERIES_SHAPE = {
  list: []
};

const projectQuery = query => {
  const byId = query.params.reduce(
    (acc, item) => ({
      ...acc,
      [item.code]: { ...item, value: "" }
    }),
    {}
  );
  const all = query.params.map(item => item.code);
  return { ...query, params: { byId, all } };
};

const projectQueries = queries => {
  const byId = queries.reduce(
    (acc, item) => ({
      ...acc,
      [item.id]: projectQuery(item)
    }),
    {}
  );
  const all = queries.map(item => item.id);
  return { all, byId };
};

export default (state = QUERIES_SHAPE, action) => {
  switch (action.type) {
    case QUERIES_LOAD_SUCCESS:
      return { ...state, list: projectQueries(action.queries) };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/queries/reducers.js